<template>
  <tr class="col-md-16">
    <td class="col-md-2">
        <TextInputField
            class="form-group" v-model="description"
            label-text="Omschrijving" hide-label=true required
            minLength="1" maxLength="255"/>
    </td>
    <td class="col-md-2">
        <NumberInputField
            class="form-group" v-model="amount"
            label-text="Hoeveelheid" hide-label=true required
            min-value="1" maxLength="40"/>
    </td>
    <td class="col-md-2">
        <TextInputField
            class="form-group" v-model="units"
            label-text="Eenheden" hide-label=true required
            minLength="1" maxLength="40"/>
    </td>
    <td class="col-md-2">
        <NumberInputField
            class="form-group"
            step="any"
            label-text="Kost"
            v-model="cost" hide-label=true required
             min-value="1" maxLength="40"/>
    </td>
    <td class="col-2">
      <div id="selector" class="form-group">
        <select v-model="selectedAccountingCost" class="form-control">
          <option value="" disabled selected>Selecteer type kost</option>
          <option v-bind:key="accountingCost.billingCode" v-bind:value="accountingCost" v-for="accountingCost in accountingCosts" >
            {{ accountingCost.name }}
          </option>
        </select>
      </div>
    </td>
    <td class="col-md-2">
      <div>
        {{ totalCost }}
      </div>
    </td>

    <td class="col-md-2">
      <div class="d-flex align-items-center">
        <button class="btn btn-fill-pulse-dark m-0" @click="cancelFreeCost()">Annuleren</button>
        <button :disabled="!canSaveFreeCost" class="btn-basic btn-green" @click="saveFreeCost()">Kost Opslaan</button>
      </div>
    </td>
  </tr>
</template>

<script>

import {toYearAndMonth} from "@/util/DateUtil";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import TextInputField from "@/components/inputFields/TextInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";

export default {
  name: "CreateFreeCostComponent",
  components: {
    TextInputField,
    NumberInputField,
  },
  data() {
    return {
      description:"",
      amount:0,
      units:"",
      cost:0.00,
      selectedAccountingCost: ""
    };
  },
  computed:{
    ...mapGetters({
      selectedContractId: "administrationTimeSheet/currentlySelectedContractId",
      timesheetYearMonth: "time/currentlySelectedMonth",
      accountingCosts: "administrationInvoice/accountingCosts"
    }),
    totalCost() {
      return this.amount * this.cost;
    },
    canSaveFreeCost() {
      return this.isTextInputValid(this.description) &&
          this.isNumberInputValid(this.amount) &&
          this.isTextInputValid(this.units) &&
          this.isNumberInputValid(this.cost) &&
          this.selectedAccountingCost !== "";
    }
  },
  async created(){
        await this.fetchAccountingCostsList();
        this.resetFields();
  },
  methods: {
    ...mapActions("administrationTimeSheet", ['addFreeCost']),
    ...mapActions("administrationInvoice", ['fetchAccountingCostsList']),
    isTextInputValid(text) {
      return text.trim().length > 0 && text.trim().length < 41;
    },
    isNumberInputValid(number) {
      return number > 0;
    },
    saveFreeCost() {
      const description = this.description;
      const amount = this.amount;
      const units = this.units;
      const cost = this.cost;
      const accountingCost = this.selectedAccountingCost;

      const createFreeCostDto = {
        description:description,
        amount:amount,
        units:units,
        cost:cost,
        accountingCostDto: accountingCost,
      };

      const yearMonth = moment(this.timesheetYearMonth).format("YYYY-MM");
      const contractId= this.selectedContractId;

      this.addFreeCost({yearMonth, contractId, createFreeCostDto})
          .then(() => {
            this.resetFields();
            this.$emit('FreeCostAdded');
          });
    },
    resetFields() {
      this.description="";
      this.amount=0;
      this.units="";
      this.cost=0.00;
      this.selectedAccountingCost = "";
    },
    cancelFreeCost() {
      this.$emit('FreeCostCanceled');
      this.resetFields();
    },
    getYearMonthAsString() {
      return toYearAndMonth(this.timesheetYearMonth);
    }
  },
};
</script>

<style scoped>

</style>